import React, { useEffect, useState } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import Switch from '@mui/material/Switch';
import WifiIcon from '@mui/icons-material/Wifi';
import BluetoothIcon from '@mui/icons-material/Bluetooth';
import ListItemButton from '@mui/material/ListItemButton'
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';



export default function UsersDeny({ users, usersDeny,rolesUsers, action }) {
    const [localUsersDeny, setLocalUsersDeny] = useState([]);

    useEffect(()=>{
        setLocalUsersDeny(usersDeny)
    },[usersDeny])


    const findRole=(id)=>{
        const rol = rolesUsers.find(role => role.id === id )
        return rol ? rol.role:''
    }

    const findUserDenny=(userId)=>{
        return localUsersDeny.some(ids => ids===userId)
    }

    const handleToggleDaddeny = (value) => () => {
        const currentIndex = localUsersDeny.indexOf(value);
        const newChecked = [...localUsersDeny];
        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }
        setLocalUsersDeny(newChecked);
        action(newChecked)
    };

    return (
        <List
            sx={{ width: '100%', bgcolor: 'background.paper' }}
            subheader={
                <ListSubheader component="div" id="nested-list-subheader" sx={{ margin:-3, top:-16, backgroundColor:'#f2f2f2', paddingLeft:5.5}}>
                    Selecciona los usuarios que podran ver y gestionar.
                </ListSubheader>
              }
        >
            {users.map((item) => (
                <>
                    <ListItem
                        alignItems="flex-end"
                        sx={{ p: 3 }}

                    >
                        <ListItemAvatar sx={{ ml: 3 }}>
                            <Avatar alt={item.name}>{item.name[0]}</Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary={`${item.name} ${item.lastName}`}

                            secondary={
                                <React.Fragment>
                                    <Typography
                                        component="span"
                                        variant="body2"
                                        sx={{ color: 'text.primary', display: 'inline' }}
                                    >
                                        {findRole(item.roleId)}
                                    </Typography>
                                     {` / ${item.email}`}
                                </React.Fragment>
                            }
                        />
                        <Switch
                            edge="end"
                            onChange={handleToggleDaddeny(item.id)}
                            checked={!findUserDenny(item.id)}
                            inputProps={{
                                'aria-labelledby': 'switch-list-label-wifi',
                            }}
                        />
                    </ListItem>
                    <Divider variant="" component="li" />
                </>
            ))}
{/* 
            <ListItem>
                <ListItemIcon>
                    <WifiIcon />
                </ListItemIcon>
                <ListItemText id="switch-list-label-wifi" primary="Wi-Fi" />
                <Switch
                    edge="end"
                    onChange={handleToggle('wifi')}
                    checked={checked.includes('wifi')}
                    inputProps={{
                        'aria-labelledby': 'switch-list-label-wifi',
                    }}
                />
            </ListItem>
            <ListItem>
                <ListItemIcon>
                    <BluetoothIcon />
                </ListItemIcon>
                <ListItemText id="switch-list-label-bluetooth" primary="Bluetooth" />
                <Switch
                    edge="end"
                    onChange={handleToggle('bluetooth')}
                    checked={checked.includes('bluetooth')}
                    inputProps={{
                        'aria-labelledby': 'switch-list-label-bluetooth',
                    }}
                />
            </ListItem> */}
        </List>
    );
}